export const STATUS_CREATED = 10;
export const STATUS_PLANNED = 20;
export const STATUS_SCHEDULED = 30;
export const STATUS_SENT = 40;
export const STATUS_DELIVERED = 50;
export const STATUS_SEEN = 60;
export const STATUS_OPENED = 70;
export const STATUS_CLICKED = 80;
export const STATUS_HIDDEN = 90;
export const STATUS_BLOCKED = 100;
export const STATUS_CANCELED = 110;
export const STATUS_GROUPED = 120;
export const checkIfRead = (status) => {
    if (getReadStatus.toString().includes(status))
        return true;
    return false;
};
export const getReadStatus = () => {
    return [STATUS_SEEN, STATUS_OPENED, STATUS_CLICKED];
};
